import React, { Suspense, lazy } from 'react';
import Collapsible from 'react-collapsible';
import { HiChevronDown, HiOutlineInformationCircle } from 'react-icons/hi';

import Map from 'react-map-gl';

import './LightMap.css';
import { ColorScale } from './colorScale.js';

// import { AnimatedPage } from '../../containers/index';

import Loading from './LightMapLoader.jsx';

const MapLayers = React.lazy(() => import('./MapLayers'));

const LightMap = () => {
    let config = {
        fillOpacity: 0.9,
        colorScale: ColorScale,
    };

    let colorScale = 'magma';

    function hex2rgb(colour) {
        var r, g, b;
        if (colour.charAt(0) == '#') {
            colour = colour.substr(1);
        }
        if (colour.length == 3) {
            colour =
                colour.substr(0, 1) +
                colour.substr(0, 1) +
                colour.substr(1, 2) +
                colour.substr(1, 2) +
                colour.substr(2, 3) +
                colour.substr(2, 3);
        }
        r = colour.charAt(0) + '' + colour.charAt(1);
        g = colour.charAt(2) + '' + colour.charAt(3);
        b = colour.charAt(4) + '' + colour.charAt(5);
        r = parseInt(r, 16);
        g = parseInt(g, 16);
        b = parseInt(b, 16);
        return [r, g, b];
    }

    function getFontColor([red, green, blue]) {
        var color;

        if (red * 0.299 + green * 0.587 + blue * 0.114 > 186) {
            color = '#000000';
        } else {
            color = '#ffffff';
        }
        return color;
    }

    const slider = document.getElementById('slider');
    const sliderValue = document.getElementById('slider-value');

    //slider.addEventListener('input', (e) => {
    // Adjust the layers opacity. layer here is arbitrary - this could
    // be another layer name found in your style or a custom layer
    // added on the fly using `addSource`.
    //    e.setPaintProperty(
    //        'chicago',
    //         'raster-opacity',
    //        parseInt(e.target.value, 10) / 100
    //    );

    // Value indicator
    //    sliderValue.textContent = e.target.value + '%';
    //});

    return (
        <Suspense fallback={<Loading />}>
            <main>
                <Map
                    initialViewState={{
                        longitude: 115.312935,
                        latitude: -33.1376622,
                        zoom: 4,
                    }}
                    style={{
                        width: '100vw',
                        height: 'calc(100vh - 128px)',
                        position: 'absolute',
                        top: '64px',
                    }}
                    mapStyle='mapbox://styles/visomec/clz86v7p7002n01oh3ifr0nxg'
                    mapboxAccessToken={
                        process.env.REACT_APP_MAPBOX_ACCESS_TOKEN
                    }
                >
                    <MapLayers />
                </Map>

                <div className='LegendContainer'>
                    <div>
                        <input
                            type='checkbox'
                            id='Info__MenuToggle'
                            className='Info__MenuToggle'
                            hidden
                        ></input>
                        <label
                            htmlFor='Info__MenuToggle'
                            className='Info__MenuToggleLabel'
                        >
                            <div
                                className='Info__Menu'
                                type='checkbox'
                            >
                                <HiOutlineInformationCircle size={25} />
                            </div>
                        </label>
                        <div className='Info'>
                            <p>
                                Original data courtesy of Falchi et al, 2016:
                                Supplement to: The New World Atlas of Artificial
                                Night Sky Brightness. V. 1.1. GFZ Data Services.
                            </p>
                            <br />
                            <a
                                className='Info__Link'
                                href='http://doi.org/10.5880/GFZ.1.4.2016.001'
                            >
                                http://doi.org/10.5880/GFZ.1.4.2016.001
                            </a>
                            <br />
                            <br />
                            <p>
                                The map shows the artificial sky brightness as a
                                ratio to the natural sky brightness above a
                                threshold of 0.01.
                            </p>
                        </div>
                    </div>
                    <div>
                        <input
                            type='checkbox'
                            id='Scale__MenuToggle'
                            className='Scale__MenuToggle'
                            hidden
                        ></input>
                        <label
                            htmlFor='Scale__MenuToggle'
                            className='Scale__MenuToggleLabel'
                        >
                            <div
                                className='Scale__Menu'
                                type='checkbox'
                            >
                                <HiChevronDown size={25} />
                            </div>
                        </label>
                        <div className='BrightnessScale'>
                            <p
                                style={{
                                    color: getFontColor(
                                        hex2rgb(
                                            config.colorScale[colorScale][0]
                                        )
                                    ),
                                    backgroundColor:
                                        config.colorScale[colorScale][0],
                                }}
                            >
                                > 41
                            </p>
                            <p
                                style={{
                                    color: getFontColor(
                                        hex2rgb(
                                            config.colorScale[colorScale][1]
                                        )
                                    ),
                                    backgroundColor:
                                        config.colorScale[colorScale][1],
                                }}
                            >
                                20.5 - 41
                            </p>
                            <p
                                style={{
                                    color: getFontColor(
                                        hex2rgb(
                                            config.colorScale[colorScale][2]
                                        )
                                    ),
                                    backgroundColor:
                                        config.colorScale[colorScale][2],
                                }}
                            >
                                10.24 - 20.5
                            </p>
                            <p
                                style={{
                                    color: getFontColor(
                                        hex2rgb(
                                            config.colorScale[colorScale][3]
                                        )
                                    ),
                                    backgroundColor:
                                        config.colorScale[colorScale][3],
                                }}
                            >
                                5.12 - 10.24
                            </p>
                            <p
                                style={{
                                    color: getFontColor(
                                        hex2rgb(
                                            config.colorScale[colorScale][4]
                                        )
                                    ),
                                    backgroundColor:
                                        config.colorScale[colorScale][4],
                                }}
                            >
                                2.56 - 5.12
                            </p>
                            <p
                                style={{
                                    color: getFontColor(
                                        hex2rgb(
                                            config.colorScale[colorScale][5]
                                        )
                                    ),
                                    backgroundColor:
                                        config.colorScale[colorScale][5],
                                }}
                            >
                                1.28 - 2.56
                            </p>
                            <p
                                style={{
                                    color: getFontColor(
                                        hex2rgb(
                                            config.colorScale[colorScale][6]
                                        )
                                    ),
                                    backgroundColor:
                                        config.colorScale[colorScale][6],
                                }}
                            >
                                0.64 - 1.28
                            </p>
                            <p
                                style={{
                                    color: getFontColor(
                                        hex2rgb(
                                            config.colorScale[colorScale][7]
                                        )
                                    ),
                                    backgroundColor:
                                        config.colorScale[colorScale][7],
                                }}
                            >
                                0.32 - 0.64
                            </p>
                            <p
                                style={{
                                    color: getFontColor(
                                        hex2rgb(
                                            config.colorScale[colorScale][8]
                                        )
                                    ),
                                    backgroundColor:
                                        config.colorScale[colorScale][8],
                                }}
                            >
                                0.16 - 0.32
                            </p>
                            <p
                                style={{
                                    color: getFontColor(
                                        hex2rgb(
                                            config.colorScale[colorScale][9]
                                        )
                                    ),
                                    backgroundColor:
                                        config.colorScale[colorScale][9],
                                }}
                            >
                                0.08 - 0.16
                            </p>
                            <p
                                style={{
                                    color: getFontColor(
                                        hex2rgb(
                                            config.colorScale[colorScale][10]
                                        )
                                    ),
                                    backgroundColor:
                                        config.colorScale[colorScale][10],
                                }}
                            >
                                0.04 - 0.08
                            </p>
                            <p
                                style={{
                                    color: getFontColor(
                                        hex2rgb(
                                            config.colorScale[colorScale][11]
                                        )
                                    ),
                                    backgroundColor:
                                        config.colorScale[colorScale][11],
                                }}
                            >
                                0.02 - 0.04
                            </p>
                            <p
                                style={{
                                    color: getFontColor(
                                        hex2rgb(
                                            config.colorScale[colorScale][12]
                                        )
                                    ),
                                    backgroundColor:
                                        config.colorScale[colorScale][12],
                                }}
                            >
                                0.01 - 0.02
                            </p>
                        </div>
                    </div>
                </div>
            </main>
        </Suspense>
    );
};

export default LightMap;
